import WallCommon from "./wallCommon";
import {createPageToLoadArray} from "../../constants";

export default class RightWall extends WallCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'right_wall';
    this.partName = 'Right Wall';
    this.dbName = 'Right Wall';
    this.translateId = "visualizer.bathroom.walls.right_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
    this.hasAdditionalParts = true;
    this.additionalPartPartId = "right_wall_crop";
    if (isChild) {
      createPageToLoadArray(this);
    }
  }

  load(dbFeature) {
    const partNumber = dbFeature.groupName === this.dbName ? 1 : 2;
    return super.load_(dbFeature, new RightWall(false, partNumber),
      true, partNumber === 1 ? 'features' : 'featuresParts');
  }

}

